import { AnyAction, Reducer } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  GlobalAssekuranzBeziehungChangedAction,
  isAzam,
  ProduktDeleted,
  ReplaceState,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import { App } from '@ps20-frontend/frontend-models';
import { Zahlungsart } from '@ps20/bff-models';
import {
  migrateAktionsnachlassAktion10, migrateAngebotsdatum,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { INITIAL_STATE } from '../initialState';
import { loadAndMigrateUnfState } from '../migrations';

export const rootReducer =
  (reducer: Reducer) =>
  (state: IAppState, action: AnyAction): IAppState => {
    switch (action.type) {
      case GlobalActions.ANGEBOTS_ID_RECEIVED: {
        return {
          ...state,
          angebotsId: action.payload,
        };
      }
      case GlobalActions.SAVED_STATES_LOADED: {
        const newState = cloneDeep(state);
        const actionPayload: WrappedSavedStates = (action as GlobalAction<WrappedSavedStatesLoaded>)
          .payload.savedStatesLoaded;
        const loadedAppState = actionPayload.find(
          loadedState =>
            loadedState.appId === App.UNF && loadedState.angebotsId === state.angebotsId,
        );
        if (
          isAzam(newState.transientState.role) &&
          newState.vertragsoptionen?.zahlungsart === Zahlungsart.MAKLER_INKASSO
        ) {
          delete loadedAppState.state.vertragsoptionen.zahlungsart;
        }
        if (loadedAppState != null) {
          migrateAngebotsdatum(loadedAppState.state);
          migrateAktionsnachlassAktion10(
            loadedAppState.state,
            newState.transientState.featureToggles,
          );
          return loadAndMigrateUnfState(
            newState,
            loadedAppState.state,
            loadedAppState.state.vertragsoptionen?.beibehalten,
          );
        } else {
          return state;
        }
      }
      case GlobalActions.PRODUKT_DELETED: {
        const actionPayload: ProduktDeleted = action.payload;
        if (
          actionPayload.angebotsIds.some(
            angebotsId =>
              angebotsId.appId === App.UNF && angebotsId.angebotsId === state.angebotsId,
          )
        ) {
          const newState: IAppState = cloneDeep(INITIAL_STATE);
          newState.vertragsoptionen.zahlungsweise = state.vertragsoptionen.zahlungsweise;
          newState.vertragsoptionen.zahlungsart = state.vertragsoptionen.zahlungsart;

          newState.versicherungsnehmer.geburtsdatum = state.versicherungsnehmer.geburtsdatum;
          newState.versicherungsnehmer.isAssekuranztarif =
            state.versicherungsnehmer.isAssekuranztarif;

          newState.transientState.role = state.transientState.role;
          return newState;
        }
        return state;
      }
      case GlobalActions.REPLACE_STATE: {
        const actionPayload: ReplaceState<IAppState> = action.payload;
        if (actionPayload.appId === App.UNF && actionPayload.angebotsId === state.angebotsId) {
          return actionPayload.appState;
        }
        return state;
      }
      case GlobalActions.ASSEKURANZ_BEZIEHUNG_CHANGED:
        return changeBeziehungVpZumVn(state, action);
      case GlobalActions.ASSEKURANZTARIF_CHANGED:
        return { ...state, beziehungVpZumVn: null };
      default:
        return reducer(state, action);
    }

    function changeBeziehungVpZumVn(
      state: IAppState,
      action: GlobalAssekuranzBeziehungChangedAction,
    ): IAppState {
      if (action.payload.angebotsId === state.angebotsId) {
        return {
          ...state,
          beziehungVpZumVn: action.payload.beziehungZumVn,
        };
      }
      return state;
    }
  };
